// src/utils/fetchWithTimeout.js

/**
 * Fetches a resource with a specified timeout.
 *
 * @param {string} url The URL to fetch.
 * @param {object} options The options for the fetch request (e.g., headers, method).
 * @param {number} timeout The timeout in milliseconds.
 * @returns {Promise<Response>} A promise that resolves with the Response object.
 * @throws {Error} Throws an error if the request times out or fails.
 */
export async function fetchWithTimeout(url, options = {}, timeout = 15000) { // 15 second timeout
  const controller = new AbortController();
  const { signal } = controller;
  options.signal = signal;

  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);

  try {
    const response = await fetch(url, options);
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Timeout');
    }
    throw error;
  }
}
